import FacebookShare from './FacebookSharingDirective';

import 'edge/platform/facebook/module';

export default angular.module('edge.platform.widgets.facebooksharing', [
    'edge.platform.facebook'
])
    .directive('gwFacebookSharing', FacebookShare);